import { useTranslation } from 'react-i18next'

import { TitleAndStoryProps } from '../Description.types'

import { Box, Icon, RichDescription, Text, Typography } from '@percent/lemonade'
import { useDateTimeFmt } from '@percent/workplace-giving/common/hooks/useDateTimeFmt/useDateTimeFmt'
import { formatShortOfflineOpportunityAddress } from '@percent/workplace-giving/utils/formatOfflineOpportunityAddress'
import { OpportunityLocationTypeDto } from '@percent/workplace-giving/api/opportunity/dto'
import classes from './TitleAndStory.module.scss'

export function TitleAndStory({ name, story, location, startDate }: Readonly<TitleAndStoryProps>) {
  const { t } = useTranslation()
  const { formatTime, formatDate } = useDateTimeFmt()

  return (
    <>
      <Typography className={classes.Title} variant="h1">
        {name}
      </Typography>

      {location?.type === OpportunityLocationTypeDto.Offline ? (
        <Box className={classes.EventLocationDetails}>
          {startDate ? (
            <>
              <Typography>{t('workplace_giving.wizard.dateAndTime')}</Typography>
              <Box>
                <Icon name="calendar" size="m" color="neutral300" />
                <Text as="p" size="small" fontWeight="medium">
                  {formatDate(new Date(startDate))}
                </Text>
              </Box>
              <Box>
                <Icon name="clock" size="m" color="neutral300" />
                <Text as="p" size="small" fontWeight="medium">
                  {formatTime(new Date(startDate))}
                </Text>
              </Box>
            </>
          ) : null}

          <Typography>{t('workplace_giving.wizard.location')}</Typography>
          <Box>
            <Icon name="pin" size="m" color="neutral300" />
            <Text as="p" size="small" fontWeight="medium">
              {formatShortOfflineOpportunityAddress({ location })}
            </Text>
          </Box>

          <Typography>{t('workplace_giving.volunteering.aboutThisOpportunity')}</Typography>
        </Box>
      ) : null}

      <RichDescription
        sanitizationConfig={{
          ADD_ATTR: ['target']
        }}
        content={`${story}`}
      />
    </>
  )
}
